// A project this tab is leaving on its own (leave, delete, transfer), so the realtime events that
// action causes do not send the tab away a second time with another notice
let exiting = null;

export function beginProjectExit(projectId) {
  exiting = projectId;
}

export function cancelProjectExit() {
  exiting = null;
}

export function isExitingProject(projectId) {
  return exiting != null && exiting === projectId;
}
